(function(){
  function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn)}
  ready(function(){
    var overlay=document.querySelector('[data-driftmini-demo]');
    if(!overlay)return;
    var shell=overlay.querySelector('[data-dm-shell]');
    var site=overlay.querySelector('[data-dm-site]');
    var cart=overlay.querySelector('[data-dm-cart]');
    var cartItems=overlay.querySelector('[data-dm-cart-items]');
    var cartCount=overlay.querySelector('[data-dm-cart-count]');
    var cartTotal=overlay.querySelector('[data-dm-cart-total]');
    var toast=overlay.querySelector('[data-dm-toast]');
    var items=[];
    var lastFocus=null;

    function closeMobileNav(){
      var nav=overlay.querySelector('.dm-demo-nav');
      var toggle=overlay.querySelector('[data-dm-nav-toggle]');
      if(nav)nav.classList.remove('is-open');
      if(toggle)toggle.setAttribute('aria-expanded','false');
    }
    function setDevice(mode){
      var mobile=mode==='mobile';
      shell.classList.toggle('is-mobile',mobile);
      closeMobileNav();
      overlay.querySelectorAll('[data-dm-device]').forEach(function(btn){
        var active=btn.getAttribute('data-dm-device')===mode;
        btn.classList.toggle('is-active',active);btn.setAttribute('aria-pressed',String(active));
      });
      site.scrollTop=0;
    }
    function open(){
      lastFocus=document.activeElement;
      overlay.hidden=false;
      overlay.setAttribute('aria-hidden','false');
      document.body.style.overflow='hidden';
      setDevice(window.innerWidth<=760?'mobile':'desktop');
      site.scrollTop=0
    }
    function close(){overlay.hidden=true;overlay.setAttribute('aria-hidden','true');document.body.style.overflow='';closeCart();if(lastFocus&&lastFocus.focus)lastFocus.focus()}
    function openCart(){cart.hidden=false;cart.setAttribute('aria-hidden','false')}
    function closeCart(){cart.hidden=true;cart.setAttribute('aria-hidden','true')}
    function money(v){return '$'+v.toFixed(2)}
    function renderCart(){
      cartCount.textContent=items.length;

      if(!items.length){
        cartItems.innerHTML='<div class="dm-demo-cart__empty"><strong>Your cart is empty</strong><p>Add a DriftMini model to see the demo cart in action.</p></div>';
        cartTotal.textContent='$0.00';
        return;
      }

      var total=0;
      cartItems.innerHTML=items.map(function(item,index){
        total+=item.price;
        return '<div class="dm-demo-cart__item">'
          +'<div class="dm-demo-cart__item-copy"><strong>'+item.name+'</strong><small>Demo product</small></div>'
          +'<div class="dm-demo-cart__item-side"><b>'+money(item.price)+'</b><button type="button" data-dm-remove="'+index+'" aria-label="Remove '+item.name+'">Remove</button></div>'
          +'</div>';
      }).join('');
      cartTotal.textContent=money(total);
    }

    function showToast(message){
      toast.textContent=message||'Added to demo cart';
      toast.hidden=false;
      window.clearTimeout(toast._timer);
      toast._timer=window.setTimeout(function(){
        toast.hidden=true;
        toast.textContent='Added to demo cart';
      },1400);
    }

    function add(product){
      if(!product)return;
      var name=product.getAttribute('data-dm-product')||'DriftMini';
      var price=parseFloat((product.getAttribute('data-dm-price')||'$0').replace(/[^0-9.]/g,''))||0;
      items.push({name:name,price:price});
      renderCart();
      showToast(name+' added');
      window.setTimeout(openCart,120);
    }

    function removeItem(index){
      index=parseInt(index,10);
      if(isNaN(index)||index<0||index>=items.length)return;
      var removed=items[index];
      items.splice(index,1);
      renderCart();
      showToast((removed&&removed.name?removed.name:'Item')+' removed');
    }
    function scrollToHash(hash){var target=overlay.querySelector(hash);if(target)target.scrollIntoView({behavior:'smooth',block:'start'})}

    window.ThemevoEmbeddedDemo=window.ThemevoEmbeddedDemo||{};
    window.ThemevoEmbeddedDemo.open=function(name){if(name==='driftmini')open()};

    document.addEventListener('click',function(e){
      var trigger=e.target.closest&&e.target.closest('[data-live-demo-link][data-embedded-demo="driftmini"]');
      if(trigger){e.preventDefault();e.stopPropagation();open();return}
      if(overlay.hidden)return;
      if(e.target.closest('[data-dm-close]')){e.preventDefault();close();return}
      var device=e.target.closest('[data-dm-device]');if(device){setDevice(device.getAttribute('data-dm-device'));return}
      var navToggle=e.target.closest('[data-dm-nav-toggle]');
      if(navToggle){
        var menu=overlay.querySelector('.dm-demo-nav');
        var openState=menu && !menu.classList.contains('is-open');
        if(menu)menu.classList.toggle('is-open',openState);
        navToggle.setAttribute('aria-expanded',String(openState));
        return
      }
      var nav=e.target.closest('[data-dm-nav]');
      if(nav){e.preventDefault();scrollToHash(nav.getAttribute('href'));closeMobileNav();return}
      var addBtn=e.target.closest('[data-dm-add]');
      if(addBtn){
        e.preventDefault();
        e.stopPropagation();
        addBtn.classList.add('is-added');
        window.setTimeout(function(){addBtn.classList.remove('is-added')},700);
        add(addBtn.closest('[data-dm-product]'));
        return;
      }

      var removeBtn=e.target.closest('[data-dm-remove]');
      if(removeBtn){
        e.preventDefault();
        removeItem(removeBtn.getAttribute('data-dm-remove'));
        return;
      }

      if(e.target.closest('[data-dm-cart-open]')){
        e.preventDefault();
        openCart();
        return;
      }
      if(e.target.closest('[data-dm-cart-close]')){
        e.preventDefault();
        closeCart();
        return;
      }
      if(e.target.closest('[data-dm-demo-checkout]')){
        e.preventDefault();
        showToast(items.length?'Demo checkout opened — no real order placed':'Add a product first');
        return;
      }
    },true);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!overlay.hidden){if(!cart.hidden)closeCart();else close()}});
    renderCart();

    window.addEventListener('resize',function(){
      if(overlay.hidden)return;
      if(window.innerWidth<=760 && !shell.classList.contains('is-mobile')) return;
      if(window.innerWidth>760 && shell.classList.contains('is-mobile')) closeMobileNav();
    });
  })
})();
